import type { RouteRecordRaw } from 'vue-router';

export const productCatalogRoutes: RouteRecordRaw[] = [
  {
    path: '/productcatalog',
    name: 'ProductCatalog',
    redirect: { name: 'MyVaultProducts' },
    meta: {
      requiresAuth: true,
      navigation: {
        label: 'Product Catalog',
        icon: 'catalog-icon.svg', // Changed from product-catalog-icon.svg to existing catalog-icon.svg
        order: 3,
        showInMenu: true,
        permissions: {
          rbacRoles: ['productcatalognav-read']
        }
      }
    },
    children: [
      {
        path: 'products/',
        name: 'MyVaultProducts',
        component: () => import("@/views/my_vault/products/Products.vue"),
        props: {
          actionPermissions: ["product-all", "product-write", "product-delete"],
          viewPermissions: ["product-read", "product-all"],
        },
        meta: {
          title: "My Vault - Products",
          requiresAuth: true,
          navigation: {
            parent: 'Product Catalog',
            parentIcon: 'catalog-icon.svg',
            label: 'Products',
            order: 1,
            showInMenu: true,
            permissions: {
              rbacRoles: ['product-read', 'product-all'],
              ownerRoles: ['Publisher', 'Retailer'],
              viewPermissions: ['product-read', 'product-all'],
              actionPermissions: ['product-all', 'product-write', 'product-delete']
            }
          }
        }
      },
      {
        path: 'products/products-add/',
        name: 'MyVaultProductsAdd',
        component: () => import("@/views/my_vault/products-add/ProductsAdd.vue"),
        props: {
          actionPermissions: ["product-all", "product-write", "product-delete"],
          viewPermissions: ["product-read", "product-all"],
        },
        meta: {
          title: "My Vault - Add Product",
          requiresAuth: true,
        }
      },
      {
        path: 'products/products-edit/:id',
        name: 'MyVaultProductsEdit',
        component: () =>
          import("@/views/my_vault/products-edit/ProductsEdit.vue"),
        props: {
          actionPermissions: ["product-all", "product-write"],
          viewPermissions: ["product-read", "product-all"],
          extraPermissions: ["product-delisted-write"],
        },
        meta: {
          title: "My Vault - Edit Product",
          requiresAuth: true,
        }
      },
      {
        path: 'products/products-preview/:id',
        name: 'MyVaultProductsPreview',
        component: () =>
          import("@/views/my_vault/products-preview/ProductsPreview.vue"),
        props: {
          actionPermissions: ["product-all", "product-write", "product-delete"],
          viewPermissions: ["product-read", "product-all"],
        },
        meta: {
          title: "My Vault - Preview Product",
          requiresAuth: true,
        }
      },
      {
        path: 'catalog-sharing/',
        name: 'MyVaultSharing',
        component: () => import("@/views/my_vault/sharing/Sharing.vue"),
        props: {
          actionPermissions: ["catalogsharing-all", "catalogsharing-write"],
          viewPermissions: ["catalogsharing-read", "catalogsharing-all"],
        },
        meta: {
          title: "My Vault - Sharing",
          requiresAuth: true,
          navigation: {
            parent: 'Product Catalog',
            parentIcon: 'catalog-icon.svg',
            label: 'Catalog Sharing',
            order: 2,
            showInMenu: true,
            permissions: {
              rbacRoles: ['catalogsharing-read', 'catalogsharing-all'],
              ownerRoles: ['Publisher'],
              viewPermissions: ['catalogsharing-read', 'catalogsharing-all'],
              actionPermissions: ['catalogsharing-all', 'catalogsharing-write']
            }
          }
        }
      },
      {
        path: 'catalog-sharing/create-rule/',
        name: 'MyVaultCreateRule',
        component: () => import("@/views/my_vault/create-rule/CreateRule.vue"),
        props: {
          actionPermissions: [
            "catalogsharingrules-all",
            "catalogsharingrules-write",
          ],
          viewPermissions: [
            "catalogsharingrules-read",
            "catalogsharingrules-read",
          ],
        },
        meta: {
          title: "My Vault - Create Rule",
          requiresAuth: true,
        }
      },
      {
        path: 'catalog-sharing/share-rules/',
        name: 'NyVaultShareRules',
        component: () => import("@/views/my_vault/share-rules/ShareRules.vue"),
        props: {
          actionPermissions: [
            "catalogsharingrules-all",
            "catalogsharingrules-write",
          ],
          viewPermissions: [
            "catalogsharingrules-read",
            "catalogsharingrules-all",
          ],
        },
        meta: {
          title: "My Vault - Share Rule",
          requiresAuth: true,
        }
      },
      {
        path: 'catalog-sharing/edit-rule/:id',
        name: 'MyVaultEditRule',
        component: () => import("@/views/my_vault/edit-rule/EditRule.vue"),
        props: {
          actionPermissions: [
            "catalogsharingrules-all",
            "catalogsharingrules-write",
          ],
          viewPermissions: [
            "catalogsharingrules-read",
            "catalogsharingrules-all",
          ],
        },
        meta: {
          title: "My Vault - Edit Rule",
          requiresAuth: true,
        }
      },
      {
        path: 'catalog-sharing/connection-details/:id',
        name: 'MyVaultConnection',
        component: () =>
          import("@/views/my_vault/connection-details/ConnectionDetails.vue"),
        props: {
          actionPermissions: [
            "catalogsharing-all",
            "catalogsharing-write",
            "catalogsharingrules-all",
            "catalogsharingrules-write",
          ],
          viewPermissions: ["catalogsharing-read", "catalogsharing-all"],
        },
        meta: {
          title: "My Vault - Connection Details",
          requiresAuth: true,
        }
      },
    ]
  }
];